import React, { useRef, useState, useEffect } from 'react';
import SearchField from './searchField/CustomSearchField';
import DropDownFilter from './TableFilters/DropDownFilter';

interface IUserTableFilter {
  searchFirstName: string | undefined;
  setSearchFirstName: (e: any) => void;
  searchLastName: string | undefined;
  setSearchLastName: (e: any) => void;
  searchEmail: string | undefined;
  setSearchEmail: (e: any) => void;
  setSelectedRoles: (s: string[]) => void;
  userRoles: string[];
  roleItems: string[];
  handleApplyRole: any;
  clearSignal?: number;
}

const UserTableFilters: React.FC<IUserTableFilter> = ({
  searchFirstName,
  searchEmail,
  searchLastName,
  setSearchEmail,
  setSearchFirstName,
  setSearchLastName,
  setSelectedRoles,
  userRoles,
  roleItems,
  handleApplyRole,
  clearSignal = 0,
}) => {
  const [searchRole, setSearchRole] = useState<string>('');
  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
  const handleClearSearch = (slug: string) => {
    if (slug === 'firstName') setSearchFirstName('');
    if (slug === 'lastName') setSearchLastName('');
    if (slug === 'email') setSearchEmail('');
  };

  const clearFilters = () => {
    setSearchEmail('');
    setSearchFirstName('');
    setSearchLastName('');
    setSearchRole('');
    setSelectedRoles([]);
    handleApplyRole([]);
  };

  useEffect(() => {
    if (clearSignal) clearFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearSignal]);

  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setDropdownOpen(false);
      }
    };

    window.addEventListener('click', handleClickOutside);

    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <tr className="filter-row">
      <th>
        <div className="filter-pair">
          <SearchField
            search={searchFirstName}
            setSearch={setSearchFirstName}
            clearSearch={handleClearSearch}
            slug="firstName"
            placeholder="First name"
          />
          <SearchField
            search={searchLastName}
            setSearch={setSearchLastName}
            clearSearch={handleClearSearch}
            slug="lastName"
            placeholder="Last name"
          />
        </div>
      </th>
      <th>
        <SearchField
          search={searchEmail}
          setSearch={setSearchEmail}
          clearSearch={handleClearSearch}
          slug="email"
          placeholder="Email"
        />
      </th>
      <th>
        <DropDownFilter
          label="Role"
          searchItems={roleItems}
          handleApply={handleApplyRole}
          selectedItems={userRoles}
          setSelectedItems={setSelectedRoles}
          search={searchRole}
          setSearch={setSearchRole}
          dropdownRef={dropdownRef}
          dropdownOpen={dropdownOpen}
          setDropdownOpen={setDropdownOpen}
        />
      </th>
      <th />
    </tr>
  );
};

export default UserTableFilters;
